// extracted by mini-css-extract-plugin
module.exports = {"alert":"_bfc8629"};